module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [(!_vm.onBoardingCompleted) ? _c('onboarding-wizard', {
    attrs: {
      "userStatus": _vm.userStatus
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-height",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "title": ("You've successfully " + _vm.fundingSourceAction + " a bank account!"),
      "closeAction": _vm.hideFundingSourceActionSuccess,
      "isShowing": _vm.showFundingSourceActionSuccess
    }
  }), _vm._v(" "), (_vm.legacyFundingSourcesExist()) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v(_vm._s(_vm.legacyFundingSourceMessageFirstLine))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.legacyFundingSourceMessageSecondLine))])]) : _vm._e(), _vm._v(" "), (_vm.showPendingMicrodepositsLabel) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length === 0) ? _c('div', {
    staticClass: "alert alert-info mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Securely connect your bank account below to seamlessly invest and receive payments to your account.")])]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0 && !_vm.showFundingTable) ? _c('div', {
    staticClass: "alert alert-info mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0 && _vm.showFundingTable) ? _c('div', {
    staticClass: "accounts-title top-margin left-margin"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Accounts list\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFundingTable),
      expression: "showFundingTable"
    }],
    staticClass: "table-responsive top-margin desktop-table"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.status === 'verified') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId),
        expression: "user.accounts[activeAccountIndex].defaultFundingSourceId"
      }],
      attrs: {
        "type": "radio",
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId = funding.id
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.type !== _vm.fundingSourceTypes.CHECK.name && funding.type !== _vm.fundingSourceTypes.WIRE_TRANSFER.name) ? _c('span', {
      staticClass: "label",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                      " + _vm._s(funding.status) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "text-red",
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.5 : 1
      }),
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeFundingSource(funding.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash"
    })]), _vm._v(" "), (funding.status !== 'verified') ? _c('button', {
      staticClass: "btn btn-details btn-outline btn-confirm-microdeposit",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.redirectToConfirmMicrodepositPage(funding.id)
        }
      }
    }, [_vm._v("Confirm Micro-deposit")]) : _vm._e()])])
  }))]), _vm._v(" "), (_vm.fundingSources.length > 1 && _vm.showFundingTable) ? _c('p', {
    staticClass: "left-margin top-margin"
  }, [_c('i', [_vm._v("Please note you cannot select an unverified bank account as your default.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFundingTable),
      expression: "showFundingTable"
    }],
    staticClass: "mobile-card-view"
  }, [_c('div', {
    staticClass: "funding-cards-mobile"
  }, _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('div', {
      key: index,
      staticClass: "funding-card-mobile"
    }, [_c('div', {
      staticClass: "funding-card-mobile-header"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-title-section"
    }, [_c('div', {
      staticClass: "funding-card-mobile-title"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))]), _vm._v(" "), (funding.type !== _vm.fundingSourceTypes.CHECK.name && funding.type !== _vm.fundingSourceTypes.WIRE_TRANSFER.name) ? _c('span', {
      staticClass: "label funding-card-mobile-status",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                      " + _vm._s(funding.status) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-body"
    }, [_c('div', {
      staticClass: "funding-card-mobile-row"
    }, [_c('span', {
      staticClass: "funding-card-mobile-label"
    }, [_vm._v("Account name:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-mobile-value"
    }, [_vm._v(_vm._s(funding.name))])]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-row"
    }, [_c('span', {
      staticClass: "funding-card-mobile-label"
    }, [_vm._v("Type:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))])]), _vm._v(" "), (funding.status === 'verified') ? _c('div', {
      staticClass: "funding-card-mobile-row funding-card-mobile-default"
    }, [_c('span', {
      staticClass: "funding-card-mobile-label"
    }, [_vm._v("Set as default:")]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId),
        expression: "user.accounts[activeAccountIndex].defaultFundingSourceId"
      }],
      staticClass: "funding-radio-input",
      attrs: {
        "type": "radio",
        "id": ("mobile-funding-" + (funding.id)),
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId = funding.id
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'funding-radio-label': true, 'is-default': _vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId === funding.id
      },
      attrs: {
        "for": ("mobile-funding-" + (funding.id))
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId === funding.id ? 'Default account' : 'Make default') + "\n                      ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-actions"
    }, [(funding.status !== 'verified') ? _c('button', {
      staticClass: "btn btn-mobile-action btn-verify",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.redirectToConfirmMicrodepositPage(funding.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    }), _vm._v(" Confirm Micro-deposit\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-mobile-action btn-delete",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeFundingSource(funding.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete account\n                  ")])])])
  })), _vm._v(" "), (_vm.fundingSources.length > 1) ? _c('p', {
    staticClass: "mobile-note"
  }, [_c('i', [_vm._v("Please note you cannot select an unverified bank account as your default.")])]) : _vm._e()]), _vm._v(" "), (_vm.fundingSourcesTypeBankLength >= _vm.maxAmountFundingSources) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.user.accounts[_vm.activeAccountIndex].accountType !== 'INSTITUTION' && !_vm.disableInvestment) ? _c('button', {
    staticClass: "btn btn-default btn-lg x-space addButton top-margin",
    attrs: {
      "disabled": _vm.isReadOnly || (_vm.fundingSourcesTypeBankLength >= _vm.maxAmountFundingSources) || _vm.isStateRestricted(_vm.user.residentialAddress.state),
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.verifyPrimaryInvestor()
      }
    }
  }, [_vm._v("\n              Add a bank account\n          ")]) : _vm._e()], 1)], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Manage bank accounts\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note you have pending micro-deposits for bank accounts below.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note that you don't have linked bank accounts at the moment.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Securely connect your bank account below to seamlessly invest and receive payments to your account.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bank name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funding-card-mobile-icon"
  }, [_c('i', {
    staticClass: "fa fa-university"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 left-margin"
  }, [_c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v("The maximum number of online bank accounts is 3.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27006fb9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddFundingSource.vue
// module id = 2124
// module chunks = 1